import React from "react";
import { Column } from "@ant-design/plots";
import { formatDataNumberToen } from "../../helper/helper";

export default function RevenueOfChannelChart({ dataChart }) {
  const { data, xField, yField } = dataChart;
  const config = {
    data,
    xField,
    yField,
    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)}`,
      },
    },
    tooltip: {
      formatter: (datum) => ({
        name: yField[0],
        value: `${formatDataNumberToen(+datum[yField])}`,
      }),
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };
  return (
    <div className="container">
      <Column {...config} />
    </div>
  );
}
